import React, { useEffect, useState } from "react";
import { useAction } from "convex/react";
import { useUser } from "@clerk/clerk-react";
import { api } from "../convex";
import toast from "react-hot-toast";

const PortalReturnSync = ({ onComplete }) => {
  const { user } = useUser();
  const syncFromPolar = useAction(api.actions.payments.syncSubscriptionFromPolar);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("portal_return") === "true" && user && !started) {
      setStarted(true);
      (async () => {
        try {
          const res = await syncFromPolar({ userId: user.id });
          if (res?.success) {
            toast.success(`Subscription synced: ${res.billingCycle}`);
          } else {
            toast.error(res?.error || "Failed to sync subscription");
          }
        } catch (e) {
          toast.error(String(e?.message || e || "Failed to sync subscription"));
        } finally {
          // Clean the URL param
          const url = new URL(window.location.href);
          url.searchParams.delete("portal_return");
          window.history.replaceState({}, document.title, url.toString());
          onComplete && onComplete();
        }
      })();
    }
  }, [user, started, syncFromPolar, onComplete]);

  return null;
};

export default PortalReturnSync;